import { Card, SPACING_2, SPACING_3, remCalc } from '@mnd-frontend/ui';
import styled from 'styled-components';

export const StepSectionWrapper = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: ${SPACING_3};
  padding: ${SPACING_3};
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING_2};
`;

export const StepForm = styled.form`
  height: 100%;
`;

export const ImgUploaderWrapper = styled.div`
  max-width: ${remCalc(350)};

  img {
    max-height: ${remCalc(150)};
    max-width: ${remCalc(300)};
  }
`;
